
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorDeCurso } from '../../controlador-detalles';
    import { Curso } from '@/__env/lib/Cursos';
    import resultados from './cursos-detalles-resultado.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            resultados,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador(): ControladorDeCurso { return Model; }
        public get Curso(): Curso { return this.Controlador.Curso; }



        protected Eventos: Function[] = [];
        beforeDestroy() { this.Eventos.forEach( x => x() ); }
        async mounted()
        {

        }


    }
